const mainDispatch = require("../store.js").dispatch;
const FileUploadActions = require("../actions/FileUploadActions.js");
const Server = require("../Server.js");

/**
 * Uploads the specified file asynchronously, dispatching Upload, Uploaded,
 * and UploadErrored events along the way, and returning a promise for the
 * HTTP POST action.
 */
function Upload(fileType, file, metadata, dispatch) {
    dispatch({
        type: FileUploadActions.Upload,
        File: file
    });

    console.log("THIS IS METADATA");
    console.log(metadata);

    return Server.PostFiles("upload-type/" + fileType.PKID + "/files", [ file.BaseFile ], metadata)
        .then((response) => {
            dispatch({
                type: FileUploadActions.Uploaded,
                File: file
            });
        })
        .catch((ex) => {
            // Put the actual response content on the error object
            ex.response.text().then((data) => {
                if (data.startsWith("{") && data.endsWith("}")) {
                    data = JSON.parse(data);
                    ex = Object.assign(ex, data);

                    if (data.errors !== undefined && data.errors[""] !== undefined) {
                        ex.message = data.errors[""].join("\r\n");
                    }
                }
                else {
                    ex.message = data;
                }

                console.log("Ex then error then JSON", ex, data);

                dispatch({
                    type: FileUploadActions.UploadErrored,
                    Error: ex,
                    File: file
                });
            });
        });
}

/**
 * Sequentially uploads each file in the specified list using recursion,
 * returning a promise that resolves just when all uploads are complete.
 */
function UploadEach(fileType, files, metadata, dispatch, resolve) {
    if (files && files.length) {
        var upload = Upload(fileType, files[0], metadata, dispatch);

        upload.then(() => {
            files = files.slice(1);

            UploadEach(fileType, files, metadata, dispatch, resolve);
        });
    }
    else {
        resolve();
    }
}

const FileUploadActionCreators = {
    Upload(fileType, file, metadata) {
        mainDispatch((thunkDispatch) => {
            return Upload(fileType, file, metadata, thunkDispatch);
        });
    },
    UploadMany(fileType, files, metadata) {
        if (!(files && files.length)) return;

        // Set each one to upload first so that the status changes
        // to "uploading" immediately.  (Note that this will be done
        // twice, but that's okay.)
        for (var i = 0; i < files.length; i++) {
            mainDispatch({
                type: FileUploadActions.Upload,
                File: files[i]
            });
        }

        mainDispatch((thunkDispatch) => {
            return new Promise((resolve) => {
                UploadEach(fileType, files, metadata, thunkDispatch, resolve);
            });
        });
    }
};

module.exports = FileUploadActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/FileUploadActionCreators.js